var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#505050"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58947 3.75L5.0478 6.66667H7.5478L6.08947 3.75H7.75613L9.21447 6.66667H11.7145L10.2561 3.75H11.9228L13.3811 6.66667H15.8811L14.4228 3.75H16.4099C16.8309 3.75 17.1872 3.89583 17.4788 4.1875C17.7705 4.47917 17.9163 4.83549 17.9163 5.25646V14.7435C17.9163 15.1645 17.7705 15.5208 17.4788 15.8125C17.1872 16.1042 16.8309 16.25 16.4099 16.25H3.58947C3.16849 16.25 2.81217 16.1042 2.52051 15.8125C2.22884 15.5208 2.08301 15.1645 2.08301 14.7435V5.25646C2.08301 4.83549 2.22884 4.47917 2.52051 4.1875C2.81217 3.89583 3.16849 3.75 3.58947 3.75ZM3.33301 7.91667V14.7435C3.33301 14.8184 3.35704 14.8799 3.40509 14.9279C3.45315 14.976 3.51461 15 3.58947 15H16.4099C16.4847 15 16.5462 14.976 16.5943 14.9279C16.6423 14.8799 16.6663 14.8184 16.6663 14.7435V7.91667H3.33301Z",
    fill: "#505050"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlateIcon);
export default __webpack_public_path__ + "static/media/slateIcon.5c5fd27c23cd55f5a9cadb8edcfa6b52.svg";
export { ForwardRef as ReactComponent };